export const CARD_IDS = [
  'spellbot',
  'joke',
  'adventure',
  'mystery_club',
  'debate_play',
  'explorer',
  'feelings',
  'guess_the_animal',
  'rhyme_time',
  'video',
  'magic_canvas',
] as const;

export const CARD_COLORS = ['green', 'yellow', 'red', 'indigo', 'pink', 'cyan', 'orange', 'blue', 'purple', 'teal', 'violet'] as const;

export const CARD_EXPERIENCES = ['chat', 'image'] as const;

export type CardId = (typeof CARD_IDS)[number];
export type CardColor = (typeof CARD_COLORS)[number];
export type CardExperience = (typeof CARD_EXPERIENCES)[number];

export interface CardDefinition {
  id: CardId;
  color: CardColor;
  experience: CardExperience;
  isAudio: boolean;
}

export const CARD_DEFINITIONS: readonly CardDefinition[] = [
  { id: 'spellbot', color: 'green', experience: 'chat', isAudio: true },
  { id: 'joke', color: 'yellow', experience: 'chat', isAudio: false },
  { id: 'adventure', color: 'red', experience: 'chat', isAudio: false },
  { id: 'mystery_club', color: 'indigo', experience: 'chat', isAudio: false },
  { id: 'debate_play', color: 'pink', experience: 'chat', isAudio: false },
  { id: 'explorer', color: 'cyan', experience: 'chat', isAudio: false },
  { id: 'feelings', color: 'orange', experience: 'chat', isAudio: false },
  { id: 'guess_the_animal', color: 'blue', experience: 'chat', isAudio: false },
  { id: 'rhyme_time', color: 'purple', experience: 'chat', isAudio: false },
  { id: 'video', color: 'teal', experience: 'chat', isAudio: false },
  { id: 'magic_canvas', color: 'violet', experience: 'image', isAudio: false },
] as const;

export const CARD_MAP = new Map<CardId, CardDefinition>(
  CARD_DEFINITIONS.map((card) => [card.id, card]),
);
